import * as React from "react";
import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

/** Must match `native-sheet-enter` duration in sheets.css */
const ENTER_ANIMATION_MS = 620;

/**
 * After the enter animation finishes, latch `native-sheet-enter-stable` so
 * typing / parent re-renders do not re-trigger the slide-up animation.
 * Do not latch on the first open frame — that killed the enter animation.
 */
export function useNativeSheetEnterStabilizer(open: boolean): string {
  const [stable, setStable] = React.useState(false);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    if (!isNativeCapacitorApp()) {
      setStable(false);
      return;
    }

    if (timerRef.current != null) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!open) {
      setStable(false);
      return;
    }

    setStable(false);
    timerRef.current = setTimeout(() => {
      setStable(true);
      timerRef.current = null;
    }, ENTER_ANIMATION_MS);

    return () => {
      if (timerRef.current != null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open]);

  return stable ? "native-sheet-enter-stable" : "";
}
